module.exports = __webpack_public_path__ + "img/13.20bfe0e6.png";